<template>
  <div v-if="alternativeGroup.length > 0" class="answer pa-2">
    <p>{{ $t('Chatbot answers') }}</p>

    <dir v-resize="onResize" style="padding: 0; margin: 0">
      <div ref="randomBar"></div>
      <div>
        <v-tabs
          v-model="currentAnswerGroup"
          :show-arrows="true"
          color="primary lighten-4"
          slider-color="primary"
          :style="{ 'max-width': `${maxRandomBarWidth}px` }"
          @change="handleChangeAnswerGroup"
        >
          <v-tab v-for="n in alternativeGroup.length" :key="n" ripple>
            {{ $t('beacon_answer_group') }} {{ n }}
          </v-tab>
        </v-tabs>
      </div>
      <div>
        <v-tabs
          v-model="currentAlternative"
          :show-arrows="true"
          color="primary lighten-4"
          slider-color="primary"
          :style="{ 'max-width': `${maxRandomBarWidth}px` }"
        >
          <v-tab v-for="n in intentItems.length" :key="n" ripple>
            {{ $t('pattern') }} {{ n }}
          </v-tab>
        </v-tabs>
      </div>

      <div class="pt-3">
        <template v-for="i in filterIntentItems.length">
          <transition
            :key="`${currentAnswerGroup}_${currentAlternative}_${i}`"
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
            @after-leave="afterLeave"
          >
            <div v-if="filterIntentItems && filterIntentItems.length > 0">
              <message-viewer
                :key="`${currentAnswerGroup}_${currentAlternative}_${timestamp}`"
                :value="filterIntentItems"
              ></message-viewer>
            </div>
            <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
          </transition>
        </template>
      </div>
    </dir>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import MessageViewer from '@/components/elements/MessageViewer'
import dayjs from 'dayjs'
import Velocity from 'velocity-animate'

export default {
  components: {
    MessageViewer
  },
  props: {
    intent: {
      default: null
    },
    tab: { default: null }
  },
  data() {
    return {
      alternativeGroup: [],
      currentAnswerGroup: 0,
      currentAlternative: 0,
      maxRandomBarWidth: 0,
      intentItems: [],
      timestamp: dayjs().format('x')
    }
  },
  computed: {
    filterIntentItems() {
      const tempData = cloneDeep(this.alternativeGroup)
      let filterData = []
      if (tempData.length > 0) {
        filterData.push(tempData[this.currentAnswerGroup][this.currentAlternative])
      }
      return filterData
    }
  },
  mounted() {
    this.handleInitialBeaconIntent()
    this.onResize()
  },
  methods: {
    handleInitialBeaconIntent() {
      const vm = this
      try {
        const tempIntent = cloneDeep(vm.intent)

        const isAnswerGroupKey = [
          'first_stage',
          'second_stage',
          'third_stage',
          'fourth_stage',
          'fifth_stage'
        ]

        const tempData = []

        isAnswerGroupKey.forEach((key) => {
          if (tempIntent[key]) {
            tempData.push(tempIntent[key])
          }
        })

        vm.alternativeGroup = tempData.length > 0 ? tempData : []

        this.intentItems = []

        if (tempData.length > 0) {
          if (tempData[this.currentAnswerGroup].length > 0) {
            const tempIntentItems = cloneDeep(tempData[this.currentAnswerGroup])
            this.intentItems.push(...tempIntentItems)
          }
        } else {
          this.intentItems.push([])
        }
      } catch (error) {
        console.error(error)
      }
    },
    onResize() {
      if (this.$refs.randomBar) {
        let randomBarWidth = this.$refs.randomBar.clientWidth
        let addRandomBtnWidth = 48
        this.maxRandomBarWidth = randomBarWidth - addRandomBtnWidth
      }
    },
    handleChangeAnswerGroup() {
      this.intentItems = this.alternativeGroup[this.currentAnswerGroup]
      this.currentAlternative = 0
      this.timestamp = dayjs().format('x')
    },

    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function (el, done) {
      setTimeout(() => {
        el.style.height = '100%'
        setTimeout(() => {
          Velocity(el, { opacity: 1, translateY: '10px' }, { complete: done, duration: 500 })
        }, 100)
      }, 600)
    },
    afterEnter: function () {},
    beforeLeave: function (el) {
      el.style.opacity = 1
    },
    leave: function (el, done) {
      Velocity(el, { opacity: 0, translateY: '-10px' }, { complete: done, duration: 500 })
    },
    afterLeave: function () {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Conversation/PreviewBeaconConversation.vue